<template>
  <v-col cols="12" class="px-0 py-3">
    <template v-for="filterName of filter">
      <v-chip
        label
        @click="onSelectFilter(filterName)"
        :key="filterName"
        :color="selectedFilter === filterName ? '#9C004726' : ''"
        :outlined="selectedFilter !== filterName"
        class="mr-1 mb-1 search-filter"
        :class="
          selectedFilter === filterName
            ? ['search-filter-active']
            : ['search-filter']
        "
      >
        {{ filterName }}
        <v-avatar
          right
          size="small"
          class="px-1"
          :class="
            selectedFilter === filterName
              ? 'search-result-count-active'
              : 'search-result-count'
          "
          >{{ getEntryCount(filterName) }}</v-avatar
        >
      </v-chip>
    </template>
  </v-col>
</template>

<script>
export default {
  name: "SearchFilter",
  props: {
    storeNamespace: {
      type: String,
      default: "search"
    }
  },
  computed: {
    filter() {
      return this.$store.getters[`${this.storeNamespace}/getFilter`];
    },
    selectedFilter() {
      return this.$store.getters[`${this.storeNamespace}/getSelectedFilter`];
    },
    getEntryCount() {
      return this.$store.getters[
        `${this.storeNamespace}/getResultCountForCategory`
      ];
    }
  },
  methods: {
    onSelectFilter(filterName) {
      this.$store.dispatch(`${this.storeNamespace}/selectFilter`, filterName);
    }
  }
};
</script>

<style scoped>
.search-filter:hover {
  border-color: #b40055;
  background: transparent !important;
  color: #b40055 !important;
}

.search-filter {
  background-color: transparent !important;
}

.search-filter-active {
  border-style: solid !important;
  border-width: thin !important;
  border-color: #b40055 !important;
  color: #b40055 !important;
  background: rgba(156, 0, 71, 0.15) !important;
}

.search-result-count {
  border-radius: 50%;
  background: #eaecef;
}

.search-result-count-active {
  border-radius: 50%;
  background: rgba(156, 0, 71, 0.15) !important;
}
</style>
